export default "__VITE_ASSET__DxJgRI4w__"